import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import OutputError from "../OutputError";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.ENCR001.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    RS <CheckCSName csName={x.cross_section} />: {x.side} encroachment station is outside of the floodplain
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.ENCR002.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    {x.side} encroachment station is within channel at RS <CheckCSName csName={x.cross_section} />.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.ENCR003.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    {x.side} encroachment station is within the ineffective flow area at RS <CheckCSName csName={x.cross_section} />.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.ENCR004.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    {x.side} encroachment station is on the right bank of the cross section at RS <CheckCSName csName={x.cross_section} />.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.ENCR00.error_id: {
            return (
                <ResultText>
                    {row.error_message}
                </ResultText>
            )
        }
        case MessageCodes.Internal.B2_NOOUT01.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        case MessageCodes.Internal.B2_NOOUT02.error_id: {
            return (
                <>
                    <OutputError error={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}


export const B2 = {
    RenderDescription,
}